import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  tableDescription: {
    maxWidth: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  readRow: {
    opacity: 0.6,
    color: token.colorTextSecondary
  },
  unreadRow: {
    fontWeight: token.fontWeightStrong
  }
}))
